import React, { useState } from 'react';
import { useAtom } from 'jotai';
import { cartListAtom } from '../../store';
import InputQuantity from '../commons/InputQuantity';

const CartItem = ({ item }) => {
    const [cartList, setCartList] = useAtom(cartListAtom);

    const handleChangeQuantity = async (q) => {
        setCartList((prev) => prev.map((cur) => {
            if (cur.id === item.id) {
                return { ...cur, count: q };
            }
            return cur;
        }));
    };

    const handleDeleteCart = async () => {
        setCartList((prev) => prev.filter((cur) => cur.id !== item.id));
    };

    return (
        <div className="bg-[#191919] flex flex-col" key={`cart-${item.id}`}>
            <button className="ml-auto" onClick={handleDeleteCart}>
                <img src="/assets/icons/icon-delete.svg" alt="delete" className="w-[20px] h-[20px]" />
            </button>

            <div className="flex w-full">
                <img 
                    src={item.pictures?.[0] || item.picture} 
                    className="w-[88px] h-[88px] object-cover bg-white border-[1px] border-gray mr-5" 
                    alt="image" 
                />

                <div className="w-full">
                    <div className="uppercase text-white text-sm">{item.title}</div>

                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                        <span className="text-white">{item.description}</span>
                    </div>

                    <div className="my-3 w-full flex justify-between text-[#717171] text-xs">
                        <span className="text-primary uppercase font-bold">
                            {item.rarity} - {item.released_year}
                        </span>
                    </div>

                    <div className="text-white flex justify-between font-bold">
                        <InputQuantity 
                            defaultValue={Number(item.count || 1)} 
                            max={Number(item.quantity || 999)} 
                            onChange={(v) => handleChangeQuantity(v)} 
                        />
                        $ {(Number(item.price || 0) * Number(item.count || 1)).toFixed(2)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
